<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-page-header :content="title" @back="back"> </el-page-header>
    <el-collapse
      v-model="activeName"
      class="mt-20px overflow-auto border"
      style="height: calc(100% - 108px)"
    >
      <el-form label-width="150px" :model="formData" ref="form" :rules="rules">
        <el-collapse-item title="指标信息" name="1">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="指标名称" prop="name">
                <el-input placeholder="请输入" v-model="formData.name" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="指标编码" prop="code">
                <el-input
                  placeholder="请输入"
                  v-model="formData.code"
                  clearable
                  :disabled="type === 'update'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="指标域" prop="metricsDmainId">
                <el-select
                  placeholder="请选择"
                  v-model="formData.metricsDmainId"
                  clearable
                  filterable
                  :filter-method="searchMetricsDmain"
                  class="!w-full"
                  popper-class="tag_select-popper"
                  ref="selectMetrics"
                  @clear="clearMetricsDmainId"
                >
                  <el-option :label="metricsDmainName" :value="formData.metricsDmainId">
                    <el-tree
                      :data="treeData"
                      :props="{
                        children: 'child',
                        label: 'name',
                      }"
                      node-key="id"
                      :current-node-key="currentNodeKey"
                      ref="tree"
                      @node-click="handleNodeClick"
                      default-expand-all
                    >
                    </el-tree> </el-option
                ></el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="计算信息" name="2">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="数据模型" prop="dataModelId">
                <el-select
                  placeholder="请选择"
                  v-model="formData.dataModelId"
                  clearable
                  filterable
                  class="!w-full"
                  @change="changeDataModelId"
                >
                  <el-option
                    v-for="(item, index) in dataModelList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <ul class="flex bg-title h-40px leading-40px border divide-x">
            <li class="w-1/3 pl-20px">
              依赖的指标
              <el-tooltip content="仅可选择已发布的指标" placement="top">
                <i class="iconfont icon-line-circleQuestion"></i>
              </el-tooltip>
            </li>
            <li class="w-1/3 pl-20px">
              展示维度
              <el-tooltip placement="top">
                <div slot="content">
                  1.展示所选指标的维度；<br />2.勾选维度将在计算结果中进行展示；
                  <br />3.使用箭头可将维度输入至表达式中。<br />4.单击可将维度复制到剪贴板。
                </div>
                <i class="iconfont icon-line-circleQuestion"></i>
              </el-tooltip>
            </li>
            <li class="w-1/3 pl-20px">
              表达式
              <el-tooltip placement="top">
                <div slot="content">
                  1.表达式中可通过计算指标维度，获得复合指标；<br />2.解析表达式后，可为每个计算维度配置数据格式。
                </div>
                <i class="iconfont icon-line-circleQuestion"></i>
              </el-tooltip>
            </li>
          </ul>
          <ul class="flex h-300px border divide-x" style="border-top: none">
            <li class="w-1/3 pl-20px pr-20px pt-10px">
              <el-select
                v-model="formData.dependMetricsIdList"
                clearable
                filterable
                multiple
                class="mb-10px w-full"
                @change="changeDependMetrics"
              >
                <el-option
                  v-for="(item, index) in dependList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </li>
            <li class="w-1/3 pl-20px pr-20px pt-10px pb-10px">
              <el-collapse v-model="activeDimension" class="overflow-auto h-full">
                <el-collapse-item
                  :title="val.name"
                  :name="val.id"
                  v-for="(val, index) in displayDimensions"
                  :key="index"
                >
                  <div v-for="(mItem, mIndex) in val.metricsData" :key="mIndex" class="flex">
                    <div class="flex-1 flex">
                      <div class="flex-1 cursor-pointer" @click="copyToClipboard(mItem)">
                        {{ mItem.metricsDimensionName }} {{ mItem.metricsDimensionCode }}
                      </div>
                      <i
                        class="iconfont icon-bg-circleRight float-right btn-color text-16px"
                        @click="addToExpression(mItem)"
                      ></i>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </li>
            <li class="w-1/3 p-10px">
              <ul class="flex h-30px">
                <li
                  class="w-30px h-30px border rounded-2px text-center leading-30px mr-5px cursor-pointer"
                  v-for="(item, index) in symbolsList"
                  :key="index"
                  @click="addToExpression(item, 'symbol')"
                >
                  {{ item }}
                </li>
              </ul>
              <codemirror
                ref="editor"
                v-model="formData.sqlExpression"
                :options="cmOptions"
                class="h-full compositExpression mt-10px"
              ></codemirror>
            </li>
          </ul>
          <ul class="h-50px leading-50px border" style="border-top: none">
            <li class="w-full h-full text-center">
              <el-button type="primary" @click="verifySqlExpression">解析表达式</el-button>
            </li>
          </ul>
          <div class="mb-20px flex items-center text-12px mt-20px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-14px">数据格式</span>
          </div>
          <el-table :data="formatData" width="100%" height="200" border>
            <el-table-column show-overflow-tooltip label="名称" prop="asName"></el-table-column>
            <el-table-column show-overflow-tooltip label="数据格式" prop="type">
              <template slot-scope="scope">
                <div class="flex">
                  <div class="w-200px">
                    <span v-if="scope.row.type === 1">无格式</span>
                    <span v-else-if="scope.row.type === 2">数值</span>
                    <span v-else-if="scope.row.type === 3">货币</span>
                    <span v-else>百分比</span>
                    (样例:{{ scope.row.currencyIdentifier }}{{ scope.row.example
                    }}{{ scope.row.unit }})
                  </div>
                  <span
                    class="btn-color cursor-pointer float-right"
                    @click="openFormatDialog(scope.row)"
                    >设置</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-row :gutter="30" class="mt-10px">
            <el-col :span="12">
              <el-form-item label="试计算">
                <el-button
                  type="primary"
                  class="iconfont icon-bg-circlePlay"
                  @click="startCalculation"
                  :loading="calcuaLoading"
                  >开始计算</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="调度信息">
                <el-tooltip
                  placement="top"
                  content="请先配置指标信息和计算信息"
                  :disabled="isDispatchConfig"
                >
                  <span>
                    <el-button
                      type="primary"
                      @click="taskSchedialogVisible = true"
                      :disabled="!isDispatchConfig"
                      >调度配置</el-button
                    >
                  </span>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="试计算结果" name="3">
          <div class="mb-20px flex items-center text-12px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-14px">语句预览</span>
          </div>
          <div class="overflow-x-auto">
            <codemirror
              ref="myCm"
              v-model="sqlExpression"
              :options="expressOptions"
              class="h-full sqlexpression"
            ></codemirror>
          </div>
          <div class="h-300px mt-10px flex">
            <ul class="h-300px w-60px write-vertical-left flex text-14px border divide-y">
              <li
                class="h-150px flex justify-center items-center bg-gray-100"
                v-for="(item, index) in tabList"
                :key="index"
                @click="changeTab(item.value)"
                :class="currentTab === item.value ? 'main-color' : ''"
              >
                {{ item.name }}
              </li>
            </ul>
            <div class="flex-1 ml-10px">
              <el-table
                v-if="currentTab === 2"
                :data="resultData"
                width="100%"
                height="300"
                border
                stripe
              >
                <el-table-column
                  v-for="(val, key, index) in tableHeader"
                  :prop="key"
                  :label="val"
                  :key="index"
                  show-overflow-tooltip
                >
                </el-table-column>
              </el-table>
              <div v-else class="w-full h-300px border">
                <div class="h-full border overflow-auto p-10px">
                  <div v-for="(item, index) in runLogMsg" :key="index">
                    {{ item.time }},{{ item.runLogMsg }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-form>
    </el-collapse>
    <div class="mt-20px text-center">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="back">取消</el-button>
    </div>

    <!-- 数据格式 -->
    <dataFormat :dialogForm="dialogForm" @updateFormat="updateFormat" />

    <!-- 调度配置 -->
    <el-dialog
      title="调度配置"
      :visible.sync="taskSchedialogVisible"
      class="mid-dialog"
      v-dialogDrag
      :close-on-click-modal="false"
      v-if="taskSchedialogVisible"
    >
      <div>
        <span class="mr-10px">有效日期:</span>
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </div>
      <cron v-model="schedulingCron" ref="cron" class="h-full w-full mt-10px"></cron>
      <div class="text-center" slot="footer">
        <el-button type="primary" size="small" @click="saveCron"> 保存 </el-button>
        <el-button size="small" @click="taskSchedialogVisible = false"> 取消 </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { codemirror } from 'vue-codemirror'
import DataModelService from '@/services/DataModelService'
import MetricsManagementService from '@/services/MetricsManagementService'
import cron from '@/components/inferenceEngine/cron'
import dataFormat from './components/DataFormat'

export default {
  name: 'CompositeMetrics',
  components: { dataFormat, cron, codemirror },
  data() {
    return {
      activeName: ['1', '2', '3'],
      formData: {
        name: '',
        code: '',
        metricsDmainId: '',
        dataModelId: '',
        dependMetricsIdList: [], // 依赖指标
        cronExpression: '', // corn表达式
        scheduleStartTime: '',
        scheduleEndTime: '',
        sqlExpression: '', // SQL语句表达式
      },
      rules: {
        name: [{ required: true, message: '请输入指标名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入指标编码', trigger: 'blur' }],
        metricsDmainId: [{ required: true, message: '请选择指标域', trigger: 'change' }],
        dataModelId: [{ required: true, message: '请选择数据模型', trigger: 'change' }],
      },
      formatData: [], // 数据格式
      dialogForm: {
        visiable: false,
        detail: {},
      },
      taskSchedialogVisible: false,
      schedulingCron: '',
      tabList: [
        { name: '运行日志', value: 1 },
        { name: '结果预览', value: 2 },
      ],
      currentTab: 2,
      treeData: [],
      currentNodeKey: '',
      metricsDmainName: '',
      type: '',
      id: '',
      title: '',
      cmOptions: {
        tabSize: 4,
        mode: 'text/x-sql',
        theme: 'base16-light',
        lineNumbers: true,
        lineWrapping: true,
        lineWiseCopyCut: true,
        showCursorWhenSelecting: true,
        matchBrackets: true,
        line: true,
        styleActiveLine: true,
        autoRefresh: true,
        connect: 'align',
        readOnly: false,
      },
      expressOptions: {
        tabSize: 4,
        mode: 'text/x-sql',
        theme: 'base16-light',
        lineNumbers: true,
        lineWrapping: true,
        lineWiseCopyCut: true,
        showCursorWhenSelecting: true,
        matchBrackets: true,
        line: true,
        styleActiveLine: true,
        autoRefresh: true,
        connect: 'align',
        readOnly: true,
      },
      time: [],
      dataModelList: [],
      activeDimension: [],
      dependList: [],
      displayDimensions: [], // 展示维度
      symbolsList: ['+', '-', '*', '/', '()', '>', '>=', '<', '<=', '=', '!='],
      currentRow: {},
      isCalculation: false, // 是否点击试计算
      sqlExpression: '', // 只展示的sql表达式
      timer: null,
      runLogMsg: '', // 运行日志
      resultData: [],
      tableHeader: {},
      isRunning: true,
      isDispatchConfig: false, // 是否可配置调度信息
      showDemensions: [],
      calcuaLoading: false,
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        if (
          newVal.name &&
          newVal.code &&
          newVal.dependMetricsIdList.length > 0 &&
          newVal.metricsDmainId &&
          newVal.dataModelId
        ) {
          this.isDispatchConfig = true
        } else {
          this.isDispatchConfig = false
        }
      },
      deep: true,
    },
  },
  methods: {
    back() {
      this.$router.push(`./metrics-management?metricsDmainId=${this.formData.metricsDmainId}`)
    },
    openFormatDialog(row) {
      this.dialogForm.visiable = true
      this.dialogForm.detail = _.cloneDeep(row)
      this.currentRow = row
    },
    // 保存调度配置
    saveCron() {
      // if (this.time.length === 0) {
      //   this.$message.warning('有效日期不能为空')
      //   return
      // }
      this.formData.cronExpression = this.schedulingCron
      this.formData.scheduleStartTime = this.time[0]
      this.formData.scheduleEndTime = this.time[1]
      this.taskSchedialogVisible = false
    },
    changeTab(val) {
      this.currentTab = val
    },
    // 根据关键字查询指标域
    async searchMetricsDmain(val) {
      const res = await MetricsManagementService.searchMetricsDmain({
        nameOrCode: val || '',
      })
      if (res && res.code === 0 && res.data) {
        this.treeData = res.data
        this.currentNodeKey = this.formData.metricsDmainId
        this.accordIdToName(this.treeData, this.currentNodeKey)
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentNodeKey)
        })
      }
    },
    // 根据指标域id查找name
    accordIdToName(data, id) {
      _.map(data, (item) => {
        if (item.id === id) {
          this.metricsDmainName = item.name
        } else if (item.id !== id && item.child && item.child.length > 0) {
          this.accordIdToName(item.child, id)
        }
      })
    },
    handleNodeClick(node) {
      this.formData.metricsDmainId = node.id
      this.metricsDmainName = node.name
      this.$refs.selectMetrics.handleClose()
    },
    clearMetricsDmainId() {
      this.formData.metricsDmainId = ''
      this.metricsDmainName = ''
    },
    // 获取数据模型(只能依赖已发布的数据模型)
    async getDataModel() {
      const res = await DataModelService.getList({
        NameOrCode: '',
        Sorting: '',
        SkipCount: 0,
        MaxResultCount: 999,
      })
      if (res && res.code === 0 && res.data) {
        this.dataModelList = _.filter(res.data, (item) => {
          return item.isPublish
        })
      }
    },
    // 修改数据模型
    changeDataModelId(val) {
      if (val) {
        this.getDependMetrics(val)
      } else {
        this.formData.dependMetricsIdList = []
        this.activeDimension = []
        this.displayDimensions = []
      }
    },
    // 获取依赖的指标
    async getDependMetrics(id) {
      const res = await MetricsManagementService.getMetricsList({
        NameOrCode: '',
        Type: '',
        IsPublish: true,
        CreatedUserName: '',
        Sorting: '',
        SkipCount: 0,
        MaxResultCount: 999,
        DataModelId: id, // 数据模型id
      })
      if (res && res.code === 0 && res.data) {
        this.dependList = res.data
      }
    },
    // 获取指标维度表名信息
    async getMetricsTableNameInfo(ids) {
      const res = await MetricsManagementService.getMetricsTableNameInfo({ metricsIds: ids })
      if (res && res.code === 0 && res.data) {
        this.displayDimensions = []
        _.map(ids, (id) => {
          const currentRow = _.find(this.dependList, ['id', id])
          const metricsData = _.filter(res.data, (item) => {
            return id === item.metricsId
          })
          this.displayDimensions.push({
            id,
            name: currentRow ? currentRow.name : '',
            metricsData,
          })
        })
        // 展示维度的数据不在数据格式里展示，只在调接口时传过去
        this.showDemensions = _.map(res.data, (item) => {
          return {
            dataModelDimensionId: item.dataModelDimensionId,
            copyValue: item.copyValue,
            asCode: item.metricsDimensionCode,
            asName: item.metricsDimensionName,
            type: 1,
            example: '1234',
            currencyIdentifier: '',
            decimalPlacesToKeep: 0,
            isPercentage: false,
            isThousandsSeparator: false,
            unit: '',
          }
        })
      }
    },
    // 修改依赖指标
    changeDependMetrics(val) {
      this.activeDimension = val
      this.getMetricsTableNameInfo(val)
    },
    // 复制到剪切板
    copyToClipboard(val) {
      const textarea = document.createElement('textarea')
      textarea.value = val.copyValue
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.info('已经成功复制到剪贴板！')
    },
    // 添加至表达式
    addToExpression(val, type) {
      let value = ''
      if (type === 'symbol') {
        // 添加符号
        value = val
      } else {
        value = val.copyValue
      }
      const post1 = this.$refs.editor.codemirror.getCursor()
      if (!post1.xRel) {
        this.formData.sqlExpression = `${this.formData.sqlExpression}${value}`
      } else {
        const post2 = {
          line: post1.line, // 行号
          ch: post1.ch, // 光标位置
        }
        this.$refs.editor.codemirror.replaceRange(value, post2) // 替换内容
      }
    },
    // 更新数据格式
    updateFormat(val, tab) {
      const index = _.findIndex(this.formatData, (item) => {
        return item.asCode === this.currentRow.asCode
      })
      if (index > -1) {
        this.currentRow.type = tab
        _.assign(
          this.currentRow,
          _.pick(val, [
            'example',
            'currencyIdentifier',
            'decimalPlacesToKeep',
            'isPercentage',
            'isThousandsSeparator',
            'unit',
          ])
        )
        this.formatData[index] = this.currentRow
        this.$set(this.formatData, index, this.currentRow)
      }
    },
    // 处理维度信息
    handleDimensionInfo() {
      const dimensionsList = []
      _.map(this.formatData, (item) => {
        dimensionsList.push({
          dataModelDimensionId: item.dataModelDimensionId,
          asCode: item.asCode,
          asName: item.asName,
          copyValue: item.copyValue,
          dataFormatDto: {
            decimalPlacesToKeep: item.decimalPlacesToKeep, // 保留小数位数
            unit: item.unit, // 度量单位
            isThousandsSeparator: item.isThousandsSeparator, // 是否使用千位分隔符
            currencyIdentifier: item.currencyIdentifier, // 货币标识
            isPercentage: item.isPercentage, // 是否百分比
          },
        })
      })
      return dimensionsList
    },
    // 开始计算
    startCalculation() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formatData.length === 0) {
            this.$message.warning('请先解析表达式')
            return
          }
          this.isCalculation = true
          this.getPreviewSql()
          this.startCompute()
        }
      })
    },
    // 获取预览sql
    async getPreviewSql() {
      const dimensionsList = this.handleDimensionInfo()
      const res = await MetricsManagementService.getPreviewSql({
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        dependMetricsIds: this.formData.dependMetricsIdList.join(','),
        metricsDmainId: this.formData.metricsDmainId,
        type: 2, // 复合指标
        dimensions: dimensionsList,
        cronExpression: this.formData.cronExpression,
        scheduleStartTime: this.formData.scheduleStartTime,
        scheduleEndTime: this.formData.scheduleEndTime,
        sqlExpression: this.formData.sqlExpression,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
      })
      if (res && res.code === 0 && res.data) {
        this.sqlExpression = res.data
      }
    },
    // 开始计算
    async startCompute() {
      const dimensionsList = this.handleDimensionInfo()
      const res = await MetricsManagementService.startCompute({
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        dependMetricsIds: this.formData.dependMetricsIdList.join(','),
        metricsDmainId: this.formData.metricsDmainId,
        type: 2, // 复合指标
        dimensions: dimensionsList,
        cronExpression: this.formData.cronExpression,
        scheduleStartTime: this.formData.scheduleStartTime,
        scheduleEndTime: this.formData.scheduleEndTime,
        sqlExpression: this.formData.sqlExpression,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
        id: this.id,
      })
      if (res && res.code === 0 && res.data) {
        const firstTime = new Date().getTime() // 第一次加载的时间
        this.setTimer(firstTime, res.data)
      }
    },
    // 获取计算信息
    async getComputeInfo(key) {
      const res = await MetricsManagementService.getComputeInfo({ key })
      if (res && res.code === 0 && res.data) {
        this.resultData = res.data.dataPreview
        this.tableHeader = res.data.dataHeader
        this.runLogMsg = _.map(res.data.runLogMsg, (item) => {
          item.runLogMsg = item.runLogMsg.replace(/\\/g, '')
          return item
        })
        // isRunning为false停止请求
        this.isRunning = res.data.runLogMsg.every((item) => {
          return item.isRunning
        })
      }
    },
    // 定时器(超过十分钟停止请求)
    setTimer(firstTime, key) {
      this.calcuaLoading = true
      this.timer = setInterval(() => {
        const currentTime = new Date().getTime() // 最新加载的时间
        if (currentTime - firstTime >= 10 * 60 * 1000 || !this.isRunning) {
          clearInterval(this.timer)
          this.calcuaLoading = false
        }
        this.getComputeInfo(key)
      }, 3000)
    },
    // 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.formData.cronExpression) {
            this.$message.warning('请先配置调度信息')
            return
          }
          if (!this.isCalculation) {
            this.$message.warning('请先进行试计算')
            return
          }
          const dimensionsList = this.handleDimensionInfo()
          if (this.type === 'update') {
            this.updateMetrics(dimensionsList)
          } else {
            this.addMetrics(dimensionsList)
          }
        }
      })
    },
    // 新增指标
    async addMetrics(dimensionsList) {
      const res = await MetricsManagementService.addMetrics({
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        dependMetricsIds: this.formData.dependMetricsIdList.join(','),
        metricsDmainId: this.formData.metricsDmainId,
        type: 2, // 复合指标
        dimensions: dimensionsList,
        cronExpression: this.formData.cronExpression,
        scheduleStartTime: this.formData.scheduleStartTime,
        scheduleEndTime: this.formData.scheduleEndTime,
        sqlExpression: this.formData.sqlExpression,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
      })
      if (res && res.code === 0) {
        this.$message.success('复合指标新增成功')
        this.back()
      }
    },
    // 编辑指标
    async updateMetrics(dimensionsList) {
      const res = await MetricsManagementService.updateMetrics({
        id: this.id,
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        dependMetricsIds: this.formData.dependMetricsIdList.join(','),
        metricsDmainId: this.formData.metricsDmainId,
        type: 2, // 复合指标
        dimensions: dimensionsList,
        cronExpression: this.formData.cronExpression,
        scheduleStartTime: this.formData.scheduleStartTime,
        scheduleEndTime: this.formData.scheduleEndTime,
        sqlExpression: this.formData.sqlExpression,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
      })
      if (res && res.code === 0) {
        this.$message.success('复合指标修改成功')
        this.back()
      }
    },
    // 验证复合指标表达式
    async verifySqlExpression() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.formData.sqlExpression) {
            this.$message.warning('表达式不能为空')
            return
          }
          const res = await MetricsManagementService.verifySqlExpression({
            name: this.formData.name,
            code: this.formData.code,
            dataModelId: this.formData.dataModelId,
            dependMetricsIds: this.formData.dependMetricsIdList.join(','),
            metricsDmainId: this.formData.metricsDmainId,
            type: 2, // 复合指标
            dimensions: this.showDemensions,
            cronExpression: this.formData.cronExpression,
            scheduleStartTime: this.formData.scheduleStartTime,
            scheduleEndTime: this.formData.scheduleEndTime,
            sqlExpression: this.formData.sqlExpression,
            createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
          })
          if (res && res.code === 0 && res.data) {
            this.formatData = _.map(res.data, (item) => {
              item.type = 1
              item.example = '1234'
              item.currencyIdentifier = ''
              item.decimalPlacesToKeep = 0
              item.isPercentage = false
              item.isThousandsSeparator = false
              item.unit = ''
              item.copyValue = ''
              return item
            })
          }
        }
      })
    },
    // 查询指标详情
    async getMetrics() {
      if (!this.id) return
      const res = await MetricsManagementService.getMetrics(this.id)
      if (res && res.code === 0 && res.data) {
        if (this.type === 'update') {
          _.assign(
            this.formData,
            _.pick(res.data, [
              'name',
              'code',
              'dataModelId',
              'metricsDmainId',
              'cronExpression',
              'scheduleStartTime',
              'scheduleEndTime',
              'sqlExpression',
            ])
          )
        } else if (this.type === 'copy') {
          _.assign(
            this.formData,
            _.pick(res.data, [
              'dataModelId',
              'metricsDmainId',
              'cronExpression',
              'scheduleStartTime',
              'scheduleEndTime',
              'sqlExpression',
            ])
          )
        }
        this.formData.dependMetricsIdList = res.data.dependMetricsIds.split(',')
        this.schedulingCron = this.formData.cronExpression
        this.time[0] = this.formData.scheduleStartTime ? this.formData.scheduleStartTime : ''
        this.time[1] = this.formData.scheduleEndTime ? this.formData.scheduleEndTime : ''
        // 获取依赖的指标下拉列表
        await this.getDependMetrics(this.formData.dataModelId)
        // 获取展示维度
        this.changeDependMetrics(this.formData.dependMetricsIdList)
        // 获取数据格式
        this.formatData = _.map(res.data.dimensions, (item) => {
          item.currencyIdentifier = item.dataFormatDto ? item.dataFormatDto.currencyIdentifier : ''
          item.decimalPlacesToKeep = item.dataFormatDto ? item.dataFormatDto.decimalPlacesToKeep : 0
          item.isPercentage = item.dataFormatDto ? item.dataFormatDto.isPercentage : false
          item.isThousandsSeparator = item.dataFormatDto
            ? item.dataFormatDto.isThousandsSeparator
            : false
          item.unit = item.dataFormatDto ? item.dataFormatDto.unit : ''
          if (item.isPercentage) {
            item.type = 4
          } else if (item.currencyIdentifier) {
            item.type = 3
          } else if (item.decimalPlacesToKeep !== 0) {
            item.type = 2
          } else {
            item.type = 1
          }
          item.example = this.handleDataFormat(item.type, item)
          return item
        })
      }
    },
    // 处理数据格式
    handleDataFormat(val, item) {
      let example = ''
      if (val === 4) {
        const value = 100
        example = `${value.toFixed(Number(item.decimalPlacesToKeep))}%`
      } else if (val === 1) {
        example = 1234
      } else {
        const value = 1234
        if (item.isThousandsSeparator) {
          example = value.toLocaleString('en-US', {
            minimumFractionDigits: Number(item.decimalPlacesToKeep),
          })
        } else {
          example = value.toFixed(Number(item.decimalPlacesToKeep))
        }
      }
      return example
    },
  },
  async created() {
    this.type = this.$route.query.type
    if (this.type === 'add') {
      this.title = '新增复合指标'
      this.formData.metricsDmainId = this.$route.query.metricsDmainId
        ? this.$route.query.metricsDmainId
        : ''
      this.metricsDmainName = this.$route.query.metricsDmainName
        ? this.$route.query.metricsDmainName
        : ''
    } else if (this.type === 'update') {
      this.title = '编辑复合指标'
      this.id = this.$route.query.id
      await this.getMetrics()
    } else if (this.type === 'copy') {
      this.title = '复制复合指标'
      this.id = this.$route.query.id
      await this.getMetrics()
    }
    this.getDataModel()
    this.searchMetricsDmain()
  },
  deactivated() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>

.main-color {
  background-color: var(--systemMainColor);
  color: var(--colorLumpText);
}
.btn-color {
  color: var(--systemMainColor);
}
.title-color {
  background-color: var(--transferTitleBg);
}
.bg-title {
  color: var(--titleTextColor);
  background-color: var(--collapseHeadHeaderBg);
  border-color: var(--collapseBorder);
}
.el-popper.tag_select-popper .el-select-dropdown__item {
  height: 100% !important;
  padding: 0;
}

</style>
<style lang="scss">

.compositExpression .cm-s-base16-light.CodeMirror {
  height: 240px !important;
}
.sqlexpression .cm-s-base16-light.CodeMirror {
  height: 50px !important;
}

</style>
